import * as React from 'react';
import {observer} from 'mobx-react';
import {IModalDialogButton, ModalDialog} from '../../components/modal-dialog';
import {FormControlCheckbox} from '../../components/form-controls/form-control-checkbox/form-control-checkbox';
import { SvgWrapper } from '../../components/svg-wrapper';
import { BatchDialogStore } from './batch-dialog-store';
import { ClientFlowHelper } from '../helpers/client-flow-helper';
import { CampusSelectorWithLabel } from '../../components/campus-selector';

@observer
export class BatchOpenPortalDialog extends React.Component<{ store: BatchDialogStore }> {
	render() {
		const { hideOpenPortalMessage, toggleHideOpenPortalMessage, checkScanningPortalAccess, selectedCampusKeyForCheckScanningPortal } = this.props.store;

		const buttons: (IModalDialogButton | JSX.Element)[] = [
			{ label: 'Cancel', dismiss: true, isPrimary: false, hideOnProgress: true },
			<button type="button" className="btn btn-default" onClick={this.openCheckScanningPortal}>
				<SvgWrapper svg="icon-follow-link" className="icon" />
				Continue
			</button>
		];

		return (
			<ModalDialog title="Open check scanning portal" buttons={buttons} showAlert={false}>
				<div className="modal-text">
					<div className="cd-batch-open-portal-dialog-heading">
						We are redirecting you to a new screen where you can start scanning your checks.
						Here are some tips before you continue
					</div>
					<ul className="cd-batch-open-portal-dialog-list">
						<li className="cd-batch-open-portal-dialog-list-item">
							<div className="cd-batch-open-portal-dialog-list-circle">
								<SvgWrapper svg="icon-deposit" className="cd-batch-open-portal-dialog-list-icon" />
							</div>
							Use the transactions tab to create a new deposit.
						</li>
						<li className="cd-batch-open-portal-dialog-list-item">
							<div className="cd-batch-open-portal-dialog-list-circle">
								<SvgWrapper svg="icon-report" className="cd-batch-open-portal-dialog-list-icon icon-report" />
							</div>
							Use the reports tab to view details for previous deposits.
						</li>
					</ul>
					{checkScanningPortalAccess && checkScanningPortalAccess.length > 1 ?
						<CampusSelectorWithLabel
							className="cd-batch-open-portal-dialog-campus-selector"
							labelForCampusSelection="Campus"
							selectedCampusKey={selectedCampusKeyForCheckScanningPortal}
							availableCampus={checkScanningPortalAccess.map(c => ({ key: c.CampusKey, campusName: c.CampusName }))}
							onChange={this.props.store.setSelectedCampusKeyForCheckScanningPortal}
							isDisabled={false}
						/> :
						<div>
							{checkScanningPortalAccess && checkScanningPortalAccess.length === 1 &&
								<div className="cd-batch-open-portal-dialog-campus-selector">
									<strong>Campus:</strong> {checkScanningPortalAccess[0].CampusName}
								</div>
							}
							<FormControlCheckbox containerClassNames="checkbox-large" value={hideOpenPortalMessage} onChangeHandler={toggleHideOpenPortalMessage} text="Don't show this message again" />
						</div>
					}
				</div>
			</ModalDialog>
		);
	}

	private openCheckScanningPortal = () => {
		ClientFlowHelper.openCheckScanningPortalWindow(this.props.store.selectedCampusKeyForCheckScanningPortal);
		this.props.store.openBeforeAllocationDialog();
	}
}
